import axios from 'axios';
import environment from 'environment';

import { JsonResponse, Pagination } from 'core/models/response';
import { PointWalletSubscription } from '../models/subscriptions';

export interface GetPointSubscriptionResponse extends PointWalletSubscription {
	pagination: Pagination;
}

export const onGetPointSubscriptions = (page = 1) => {
	return axios.get<JsonResponse<GetPointSubscriptionResponse>>(`${environment.BASE_API_ENDPOINT}/admin/subscriptions/point-subscriptions`, {
		params: { page },
	});
};
